import { isAxiosNetworkError } from "@/utils/network-error"
import { Sentry } from "@/telemetry/sentry"
import { getAxiosBackendReason } from "@/utils/error"

export function getExportCreditConsumptionFailureMessage(error: unknown): string {
	const badRequestReason = getAxiosBackendReason(error, { status: 400 })

	if (isAxiosNetworkError(error)) {
		return "Export interrupted due to internet connection loss."
	}

	Sentry.captureException(error)

	if (badRequestReason) {
		return badRequestReason
	}

	return "Something went wrong. Please try exporting again later."
}
